<div class="p-grid">
    <div class="p-md-6 p-col-12">
        <div class="p-text-bold">Document Template Id</div>
        {{documentTemplateDetail?.doctemplateId}}
    </div>
    <div class="p-md-6 p-col-12">
        <div class="p-text-bold">Document Template Name</div>
        {{documentTemplateDetail?.templateName}}
    </div>
    <div class="p-md-6 p-col-12">
        <div class="p-text-bold">Screen Name</div>
        {{documentTemplateDetail?.screenName}}
    </div>
</div>

<div class="p-grid">
    <div class="p-md-6 p-col-12">
        <div class="p-text-bold">Is Active</div>{{documentTemplateDetail?.isActive}}
    </div>
</div>

